import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { CATALOG_FEATURE, CatalogState, StateWithCatalog } from '../catalog-state';

export const getCatalogState: MemoizedSelector<StateWithCatalog, CatalogState> =
  createFeatureSelector<CatalogState>(CATALOG_FEATURE);
